module.exports = __webpack_public_path__ + "static/media/login-bg.9c39991b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-bg.jpg
// module id = 5702
// module chunks = 0